import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import "./Navbar.scss";
import korhonenLogo from "images/brands/korhonen.png";

//Component imports
import NavbarAuth from "components/NavbarAuth";

function Navbar(props) {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <header className="korhonenNav">
      <div className="korhonenNav__inner">
        <NavLink className="korhonenNav__brand" to="/transport-tasks">
          <span className="korhonenNav__logoFrame">
            <img src={korhonenLogo} alt="Transport Mikko Korhonen" />
          </span>
          <span className="korhonenNav__product">
            <strong>FleetAdmin TMS</strong>
            <small>{t("navbar.agentFirst")}</small>
          </span>
        </NavLink>
        {props.user.email && (
          <nav className="korhonenNav__links" aria-label={t("navbar.mainNavigation")}>
          <NavLink
            className="korhonenNav__link"
            activeClassName="korhonenNav__link--active"
            to="/transport-tasks"
          >
            {t("navbar.transportTasks")}
          </NavLink>
          <NavLink
            className="korhonenNav__link"
            activeClassName="korhonenNav__link--active"
            to="/drivers"
          >
            {t("navbar.drivers")}
          </NavLink>
          <NavLink
            className="korhonenNav__link"
            activeClassName="korhonenNav__link--active"
            to="/driver-conversations"
          >
            {t("navbar.driverConversations")}
          </NavLink>
          <NavLink
            className="korhonenNav__link"
            activeClassName="korhonenNav__link--active"
            to="/business-rules"
          >
            {t("navbar.businessRules")}
          </NavLink>
          <NavLink className="korhonenNav__link" activeClassName="korhonenNav__link--active" to="/reports">{t("reportQueue.title")}</NavLink>
          </nav>
        )}
        <div className="korhonenNav__tools">
          {location.pathname!=="/reports" && <span className="korhonenNav__readOnly">{t("navbar.readOnly")}</span>}
          <NavbarAuth />
        </div>
      </div>
    </header>
  );
}

const mapStateToProps = (state) => ({
  user: state.root.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
